export default {
    smartBadge: "Умный бейдж",
    basicData: "Основные данные",
    smartBradgePhone: "Номер умного бейджа",
    SmartBadgeWIFIScan: "Умный бейдж WIFIScan",
    SmartBadgeClassRoomMode: "Умный бейдж — режим класса",
    SmartBadgeAlarmClock: "Умный бейдж — будильник",
    SmartBadgeCallRecord: "Журнал звонков умного бейджа",
    SmartBadgeLbs: "Умный бейдж LBS",
    SmartBadgeStepLogs: "Журнал шагов умного бейджа",
    SmartBadgeGnssRecords: "Журнал GNSS умного бейджа",
    SmartBadgeGnssFenceRecords: "Журнал gnss_fence умного бейджа",
    BasicInformation: "Основная информация",
    SOSalarmOn: "Тревога SOS включена",
    SOSalarmOff: "Тревога SOS выключена",
    EnableAudioCalibration: "Включить калибровку аудио",
    AudioCalibrationComplete: "Калибровка аудио завершена",

    AlarmClock: "Будильник",
    selectTime: "Выберите время",
    content15: "Длина содержимого звонка не более 15 символов",
    Effectivetime: "Время вступления в силу",
    Duration: "Длительность/сек",
    RingtoneContent: "Содержимое звонка",
    RepeatDateView: "Просмотр повторяющихся дат",
    RepeatCycle: "Цикл повтора",
    RingtoneName: "Название звонка",
    alarmNoEmpty: "Время начала будильника не может быть пустым",
    AlarmNumber: "Номер будильника",
    EffectiveStatus: "Статус действия",
    startTime: "Время начала будильника",
    AlarmDuration: "Длительность будильника",
    Monday: "Понедельник",
    Tuesday: "Вторник",
    Wednesday: "Среда",
    Thursday: "Четверг",
    Friday: "Пятница",
    Saturday: "Суббота",
    Sunday: "Воскресенье",
    Effective: "Действует",
    noNull: "Не может быть пустым",

    fenceMode: "Режим геозоны",
    setVoice: "Воспроизведение голосового сообщения",
    LocationData: "Данные местоположения",
    playRingtone: "Воспроизвести звонок",
    RestoreFactory: "Сброс к заводским настройкам",
    otherSettings: "Прочие настройки",
    the: "№",
    gear: "уровень",
    exceedingT: "Отчёт при превышении порога",
    belowT: "Отчёт при значении ниже порога",
    pageLost: "Страница не найдена",
    BatteryInfo: "Информация о заряде",
    factory: "Выполнить сброс к заводским настройкам?",
    characters30: "Длина воспроизводимого текста не более 30 символов",
    HeartbeatTime: "Интервал heartbeat (сек)",
    SOSAlarm: "Состояние тревоги SOS",
    SOSAlarmOn: "Тревога SOS включена",
    SOSAlarmOff: "Тревога SOS выключена",
    CountryCode: "Код страны",
    CarrierCode: "Код оператора",
    BaseStation: "Базовая станция",
    residential: "Зона",
    VolumeLevel: "Уровень громкости",
    SilentMode: "Тихий режим",
    AudioCalibration: "Калибровка аудио",
    NotCalibrated: "Не откалибровано",
    Calibrating: "Калибровка",
    UnreadSMS: "Непрочитанные SMS",
    PedometerSensitivity: "Чувствительность шагомера",
    ElectronicMode: "Режим геозоны",
    HeartbeatPriority: "Приоритет локации heartbeat",
    VoltageStatus: "Напряжение",
    Voltage: "Напряжение",
    LowVoltage: "Порог низкого напряжения",
    HighVoltage: "Порог высокого напряжения",
    BatteryStatus: "Заряд",
    BatteryLevel: "Уровень заряда",
    LowLevel: "Порог низкого заряда",
    HighLevel: "Порог высокого заряда",
    PlaybackContent: "Содержимое воспроизведения",
    enterEontent: "Введите содержимое воспроизведения",
    PlaybackType: "Тип воспроизведения",
    PlayImmediately: "Воспроизвести сразу",
    Sendprompts: "Отправить голосовое SMS на устройство (уведомление без воспроизведения)",

    positionS: "Локация успешна",
    positionF: "Локация не удалась",
    playS: "Воспроизведение успешно",
    playF: "Воспроизведение не удалось",

    CallRecordInfo: "Информация о звонках умного бейджа",
    I_O_Indicator: "Входящий/исходящий",
    CallStatus: "Статус звонка",
    CallDuration: "Длительность (сек)",
    CallTime: "Время звонка",
    Inbound: "Входящий",
    Outbound: "Исходящий",
    NotConnected: "Не соединён",
    Connected: "Соединён",

    ClassroomMode: "Умный бейдж — режим класса",
    SetCM: "Настройка режима класса",
    ClassroomNum: "Номер класса",
    STCBE: "Время начала не может быть пустым",
    ETCBE: "Время окончания не может быть пустым",

    gnssInfo: "Информация о записях GNSS умного бейджа",
    TAM: "Время",
    HDOP: "Горизонтальная точность",
    Altitude: "Высота",
    PositionType: "Тип позиции",
    MotionAngle: "Угол движения",
    HorizontalVelocity: "Горизонтальная скорость",
    CurrentDate: "Текущая дата",
    NOSUIP: "Количество спутников",
    DPI: "Идентификатор дифференциальной локации",
    NotPositioned: "Не локализован",
    Positioning2D: "2D-локация",
    Positioning3D: "3D-локация",
    Invalid: "Недействительно",
    SPP: "Одиночная точка",
    DP: "Дифференциальная локация",
    gnssRecord: "Информация о записях GNSS умного бейджа",
    height: "Высота",
    lbsInfo: "Информация LBS умного бейджа",
    recordTime: "Время записи",
    phoneInfo: "Информация о номере умного бейджа",
    setPhone: "Настроить контакты",
    phoneNum: "Номер контакта",
    phone: "Номер телефона",
    phoneType: "Тип номера",
    abPhone: "Близкие",
    SOSPhone: "Номер SOS",
    whitePhone: "Белый список",

    StepRecord: "Информация о шагах умного бейджа",
    stepCount: "Количество шагов",
    WiFiScan: "Умный бейдж WIFIScan",
    wifiStrength: "Сила сигнала",
}
